import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './custom-filter-template.pug';

const i18n = globalContext.require('component/i18n/loader!campaignui/feature/hotel-center');

/**
 * Class representing a CustomFilterView
 * @extends View
 */
export default class CustomFilterView extends DeterministicView {
  initialize() {
    this.i18n = i18n;
  }

  get events() {
    return {
      'click .removeFilterLink': this.onRemoveFilterLinkClicked,
    };
  }

  get template() {
    return template;
  }

  onRemoveFilterLinkClicked(e) {
    this.removeFilterLinkClickedEvent = e;
    this.trigger('filterRemoved');
  }
}
